import { FieldsType, getErrorMessage, getFieldErrorMessages } from '@/api/exceptions/messages';
import { ApiException } from '../exceptions/ApiException';
import { EXCEPTION_CODES } from '@/api/exceptions/codes';

export type ErrorResponse = {
  code: EXCEPTION_CODES;
  fields?: FieldsType;
};

export default function errorFactory(error: ErrorResponse) {
  const code = error.code;
  const fields = error.fields;

  const message = getErrorMessage(code);
  const fieldMessages = getFieldErrorMessages(fields);

  return new ApiException(message, code, fieldMessages);
}
